import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./passwordResetStyle.css";
import "aos/dist/aos.css";
import { ToastContainer, toast } from "react-toastify";
import Cookies from "js-cookie";

export default function PasswordReset() {
    const navigate = useNavigate();

    const [step, setStep] = useState(1);
    const [email, setEmail] = useState("");
    const [code, setCode] = useState("");
    const [password, setPassword] = useState("");
    const [passwordRepeat, setPasswordRepeat] = useState("");

    useEffect(() => {
        document.title = "DJ - EMAN"
    }, []);

    function switchSide(side) {
        navigate(side);
    }

    const requestResetCode = async (e) => {
        e.preventDefault();

        try {
            const response = await fetch("https://djeman.de:8443/api/v1/requestpasswordreset?email=" + email, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
            });

            if (response.status == 200) {
                setStep(2);
                toast.info("Du hast eine E-Mail mit einem Autorisierungscode erhalten");
            } else {
                toast.error("Die Anfrage für dein Passwort Reset war Fehlerhaft");
            }
        } catch (error) {
            console.error("Fehler beim API Request: ", error);
        }
    }

    const requestCodeCheck = async (e) => {
        e.preventDefault();

        try {
            const response = await fetch("https://djeman.de:8443/api/v1/requestcodecheck?code=" + code, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
            });

            if (response.status == 200) {
                setStep(3);
                toast.success("Du wurdest erfolgreich Autorisiert");
            } else {
                toast.error("Dieser Autorisierungscode ist ungültig");
                setCode("");
            }
        } catch (error) {
            console.error("Fehler beim API Request: ", error);
        }
    }

    const requestNewPassword = async (e) => {
        e.preventDefault();

        const newPasswordRequestData = {
            password: password,
            passwordRepeat: passwordRepeat,
            email: email,
            code: code,
        }

        try {
            const response = await fetch("https://djeman.de:8443/api/v1/requestnewpassword", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(newPasswordRequestData),
            });

            if (response.status == 200) {
                switchSide("/login");
                setStep(1);
                setEmail("");
                setPassword("");
                setPasswordRepeat("");
            } else {
                toast.error(await response.text());
                setCode("");
            }
        } catch (error) {
            console.error("Fehler beim API Request: ", error);
        }
    }

    return (
        <div className="passwordResetContainer">
            <ToastContainer
                theme="dark"
            />
            <h1>Passwort Reset</h1>
            <h2>Du hast dein Passwort vergessen? Kein Problem...</h2>
            <div className="passwordResetDataContainer">
                    {step === 1 && (
                        <>
                            <h3>Schritt 1</h3>
                            <form onSubmit={requestResetCode}>
                                <input
                                    type="text"
                                    placeholder="E-Mail"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                                <button type="submit">Code schicken</button>
                            </form>
                            <p>Wir brauchen deine E-Mail Adresse, mit welcher <br /> du deinen Account ursprünglich erstellt hattest</p>
                        </>
                    )}

                    {step === 2 && (
                        <>
                            <h3>Schritt 2</h3>
                            <form onSubmit={requestCodeCheck}>
                                <input
                                    type="text"
                                    placeholder="Code"
                                    value={code}
                                    onChange={(e) => setCode(e.target.value)}
                                />
                                <button type="submit">Code prüfen</button>
                            </form>
                            <p>Prüfe dein E-Mail Postfach auf unseren <br /> zugeschickten Autorisierungs Code</p>
                        </>
                    )}

                    {step === 3 && (
                        <>
                            <h3>Schritt 3</h3>
                            <form onSubmit={requestNewPassword}>
                                <input
                                    type="text"
                                    placeholder="Neues Passwort"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                />

                                <input
                                    type="text"
                                    placeholder="Neues Passwort wiederholen"
                                    value={passwordRepeat}
                                    onChange={(e) => setPasswordRepeat(e.target.value)}
                                />
                                <button type="submit">Passwort zurücksetzen</button>
                            </form>
                            <p>Gebe dein neues Passwort ein</p>
                        </>
                    )}
            </div>
        </div>
    )
}
